
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StyledSelect from 'components/atoms/inputs/Select';

class SelectList extends Component {
    render() {
        const { list = [], input, filter = [], disabledDefault = false, nameTransform } = this.props;
        return (
            <StyledSelect {...input}>
                <option value='' className="choose" {...(disabledDefault ? { disabled: true } : {})}>
                    CHOOSE ONE...
                </option>
                {list.filter(item => !filter.includes(item.id)).map((item, index) => (
                    <option key={index} value={item.id} {...(item.disabled ? { disabled: true } : {})}>
                        { nameTransform ? nameTransform(item) : item.name }
                    </option>
                ))}
            </StyledSelect>
        );
    }
}

SelectList.propTypes = {
    list: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        id: PropTypes.any
    })).isRequired,
    filter: PropTypes.arrayOf(PropTypes.any)
};


export default SelectList;



// WEBPACK FOOTER //
// ./src/components/atoms/inputs/SelectList.js